import React from 'react';
import { Container, Box, Link as LinkMui } from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { BottomSafeArea } from '../../components';
import { AppContext } from '../../contexts/app_context';

// eslint-disable-next-line import/prefer-default-export
export const ThankYouPage = () => {
  const { setContextIsLogin } = React.useContext(AppContext);

  return (
    <Container
      maxWidth="sm"
      sx={{ paddingY: 2, height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <Box textAlign="center">
        <TaskAltIcon sx={{ fontSize: 80 }} />
        <p> ลงทะเบียนเรียบร้อย ทีมงานจะติดต่อกลับภายใน 24 ชั่วโมง </p>
        <LinkMui href="/" rel="noopener">
          <p>กลับหน้าหลัก</p>
        </LinkMui>
      </Box>
      <BottomSafeArea />
    </Container>
  );
};
